import { cx } from "@emotion/css";
import type { ReactNode } from "react";
import { GlobalSearch } from "src/components/GlobalSearch/GlobalSearch";

interface LayoutWithSearchProps {
	className?: string;
	children: ReactNode;
}

export function LayoutWithSearch({
	className,
	children,
}: LayoutWithSearchProps) {
	return (
		<div className={cx("flex flex-col gap-12", className)}>
			<GlobalSearch />
			{children}
		</div>
	);
}
